import { EN_TETES_DU_CONTEXTE, type AngleAffiche, type Appareil, type Courage } from '@nextilt/commun';

/**
 * **Le contexte de chaque geste** (chantier journal-des-gestes, ticket 05) : l'appareil, l'angle
 * affiché et, quand le geste part de Maintenant, le courage choisi. Les écrans le posent ici
 * (`useContexteDesGestes.ts`), le seul module d'appels (`api/client.ts`) le joint à chaque
 * requête, comme le fuseau. Le serveur le note au journal des gestes, rien d'autre ne le lit :
 * aucun écran ne change, ni sa vitesse.
 *
 * Ce n'est pas un état d'écran : une mémoire de la page, perdue avec elle, comme ce que la
 * feuille dit au tuto (`aide/ecranDuTuto.ts`).
 */

let appareil: Appareil | null = null;
let angle: AngleAffiche | null = null;
let courage: Courage | null = null;

/** L'appareil, dit par `useAuPouce` (téléphone sous 720 px, sinon ordinateur). */
export function poserLAppareil(a: Appareil | null): void {
  appareil = a;
}

/** L'angle affiché : celui de la feuille, ou de la page Maintenant ou Agenda ; `null` ailleurs. */
export function poserLAngle(a: AngleAffiche | null): void {
  angle = a;
}

/** Le courage choisi dans Maintenant, tant que Maintenant est à l'écran ; `null` ailleurs. */
export function poserLeCourage(c: Courage | null): void {
  courage = c;
}

/** Les en-têtes du contexte, seulement ce qui est posé. */
export function enTetesDuContexte(): Record<string, string> {
  return {
    ...(appareil ? { [EN_TETES_DU_CONTEXTE.appareil]: appareil } : {}),
    ...(angle ? { [EN_TETES_DU_CONTEXTE.angle]: angle } : {}),
    ...(courage ? { [EN_TETES_DU_CONTEXTE.courage]: courage } : {}),
  };
}
